var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40741 1.46484V7.96484C9.40741 8.09745 9.35474 8.22463 9.26097 8.3184C9.1672 8.41217 9.04002 8.46484 8.90741 8.46484C8.77481 8.46484 8.64763 8.41217 8.55386 8.3184C8.46009 8.22463 8.40741 8.09745 8.40741 7.96484V2.67172L1.26116 9.81859C1.16734 9.91241 1.04009 9.96512 0.907413 9.96512C0.774731 9.96512 0.647483 9.91241 0.553663 9.81859C0.459843 9.72477 0.407135 9.59753 0.407135 9.46484C0.407135 9.33216 0.459843 9.20491 0.553663 9.11109L7.70054 1.96484H2.40741C2.2748 1.96484 2.14763 1.91217 2.05386 1.8184C1.96009 1.72463 1.90741 1.59745 1.90741 1.46484C1.90741 1.33224 1.96009 1.20506 2.05386 1.11129C2.14763 1.01752 2.2748 0.964844 2.40741 0.964844H8.90741C9.04002 0.964844 9.1672 1.01752 9.26097 1.11129C9.35474 1.20506 9.40741 1.33224 9.40741 1.46484Z",
    fill: "#45852E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenarrow);
export default __webpack_public_path__ + "static/media/greenarrow.c7a8572f09a6140d9fd2fa92ebfb0d00.svg";
export { ForwardRef as ReactComponent };